export const REGEXP_PATTERNS = {
  SIGNED_NUMBER_0_DECIMALS: "^-?(?:0|[1-9][0-9]*)$",
  SIGNED_NUMBER_1_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9])?$",
  SIGNED_NUMBER_2_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,2})?$",
  SIGNED_NUMBER_3_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,3})?$",
  SIGNED_NUMBER_4_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,4})?$",
  SIGNED_NUMBER_5_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,5})?$",
  SIGNED_NUMBER_7_DECIMALS: "^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,7})?$",

  // Función para generar patrones dinámicamente
  DECIMAL_PLACES: (decimals: number): string => {
    if (decimals === 0) {
      return "^-?(?:0|[1-9][0-9]*)$";
    }
    if (decimals === 1) {
      return "^-?(?:0|[1-9][0-9]*)(\\.[0-9])?$";
    }
    return `^-?(?:0|[1-9][0-9]*)(\\.[0-9]{1,${decimals}})?$`;
  }
};

